import React, { useContext, useEffect, useState } from "react";
import "../../../assets/AdminCss/admin_roles.css";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../context/Authcontext";
import { base_url } from "./AgentWhitelist";

const AdminRoles = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [roles, setRoles] = useState([]);
  const [permit, setPermit] = useState([]);
  const { getRoles } = useContext(AuthContext);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const fetchRoles = async () => {
    const auth = localStorage.getItem("admin");
    try {
      const response = await axios.post(
        base_url + "/api/webapi/admin/Rolelist",
        {},
        {
          headers: {
            "content-type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );
      if (!response.data.status) {
        throw new Error("failed to fetch users");
      }
      setRoles(response.data.data);
    } catch (error) {
      console.log("err", error);
    }
  };

  const fetch = async () => {
    const auth = localStorage.getItem("admin");
    const role = localStorage.getItem("role");

    try {
      const roles = await getRoles(auth, role);
      roles.map((roll) => {
        const arr = Object.values(roll);
        arr.map((role) => {
          role.map((mapp) => {
            const asn = Object.keys(mapp);
            if (asn.includes("roles")) {
              const vall = Object.values(mapp);
              vall.map((per) => {
                setPermit(per);
              });
            }
          });
        });
      });
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    fetchRoles();
    fetch();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="wrapper">
      {/* Sidebar */}
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />

      {/* Header */}
      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      {/* Content */}
      <div
        className={`content-wrapper d-flex flex-column ${
          !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
        }`}
        style={{
          marginLeft: !isMobile && isSidebarOpen ? "" : "0",
          transition: "margin-left 0.3s ease",
        }}
      >
        <div className="container-fluid py-4">
          {/* Title + Add Button */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h1 className="page-title fw-bold text-dark border-bottom pb-2">
              Roles
            </h1>
            {permit.includes("Add Roles") && (
              <Link
                to="/admin/add_roles"
                className="btn btn-primary shadow-sm px-4 py-2 rounded-pill"
              >
                <i className="fa fa-plus me-2"></i> Add New
              </Link>
            )}
          </div>

          {/* Roles Table Card */}
          <div className="card table-responsive shadow-lg border-0 rounded-3 w-100">
            <div className="card-body table-responsive w-100">
              <table className="table-hover align-middle w-100">
                <thead style={{ backgroundColor: "#182848", color: "white" }}>
                  <tr>
                    <th className="px-3">Name</th>
                    <th className="px-3">Display Name</th>
                    {permit.includes("Edit Role") && <th className="px-3">Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {roles?.map((roleObj, idx) => (
                    <tr key={idx}>
                      <td className="px-3">{Object.keys(roleObj)}</td>
                      <td className="px-3">{Object.keys(roleObj)}</td>
                      {permit.includes("Edit Role") && (
                        <td className="px-3">
                          <button
                            onClick={() =>
                              navigate("/admin/add_roles", { state: { roleObj } })
                            }
                            className="btn btn-sm btn-outline-primary rounded-pill px-3"
                          >
                            <i className="fa fa-edit me-1"></i>Edit
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
                  {roles?.length === 0 && (
                    <tr>
                      <td colSpan="3" className="text-muted py-4">
                        No roles found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminRoles;
